import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../environments/environment';

@Pipe({
  name: 'imageUrl'
})
export class ImageUrlPipe implements PipeTransform {
  private readonly baseUrl = environment.flightConfig.apiUrl;
  
  transform(carrier: string): string {
    return `${this.baseUrl}img/air_logos/${carrier}.png`;
  }

}
